export enum LabsConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'labs/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'labs/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_DATE = 'labs/SET_DATE',
  SET_TIME = 'labs/SET_TIME',
  SET_DATE_TIME = 'labs/SET_DATE_TIME',
  SET_ASSESSED_BY = 'labs/SET_ASSESSED_BY',
  SET_ROLE_PERFORMING = 'labs/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'labs/SET_ROLE_PERFORMING_PNNV',
  SET_ATTEMPTS = 'labs/SET_ATTEMPTS',
  SET_SUCCESSFUL_ATTEMPT = 'labs/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'labs/SET_PTA',
  SET_LAB_VALUE = 'labs/SET_LAB_VALUE',
  SET_PROCEDURE_COMPLICATIONS = 'labs/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'labs/SET_AUTHORIZATION',
  SET_COMMENTS = 'labs/SET_COMMENTS',
  SAVE_LABS = 'labs/SAVE_LABS',
  RESET_STATE = 'labs/RESET_STATE',
  SET_STATE = 'labs/SET_STATE',
  METABOLIC_CATRGORY = 'Metabolic Panel',
  CARDIAC_CATRGORY = 'Cardiac',
  CBC_CATRGORY = 'Complete Blood Count',
  BLOOD_GASSES_CATRGORY = 'Blood Gases',
  COAGULATION_CATRGORY = 'Coagulation Panel',
  OTHER_CATRGORY = 'Other',
  ABG_ACCESS = 'ABG_ACCESS',
  LABS_NEMSIS_CODE = 386521001,
}
